__webpack_require__.p = "/Swipe-assignment/";